const powDialog = {
    "Natasha Ali": {
        "introduction": {
            "text": ["Hi? Oh, you're the new booker."],
            "choices": [
                {
                    "text": ["Tell me about yourself Natasha."],
                    "reply": {
                        "text": ["Okay. I joined POW a few months ago. I've done a few matches here and there but nothing big. Hank said he sees a lot in me but he probably says that to everyone."],
                        "choices": [
                            {
                                "text": ["You don't see yourself becoming a star?"],
                                "reply": {
                                    "text": ["No. I mean I just got here. Maybe once I'm good enough, but that's a long time away."],
                                    "choices": []
                                }
                            }
                        ]
                    }
                },
                {
                    "text": ["Okay, see you."],
                    "reply": {
                        "text": ["Okay."],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "normal": {
            "text": ["Hi."],
            "choices": [
                {
                    "text": ["How would you like to be POW champion?"],
                    "reply": {
                        "text": ["Me? No way, I'm not ready. I'm not even a main eventer. The fans would hate it. I can't be the champion."],
                        "choices": [
                            {
                                "text": ["Why don't you think you're good enough?"],
                                "reply": {
                                    "text": ["I don't know. I just think other women deserve it more. I don't want them to hate me, or the fans to hate me."],
                                    "choices": []
                                }
                            }
                        ]
                    }
                },
                {
                    "text": ["What do you think of Hank?"],
                    "reply": {
                        "text": ["Hank was really kind to hire me. I didn't have much experience wrestling, and being an immigrant with a name like mine didn't really make me a promised star. But he gave me a shot, and I guess I have to prove that he didn't make a mistake."],
                        "choices": []
                    }
                },
                {
                    "text": ["See you later."],
                    "reply": {
                        "text": ["Okay."],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "confident": {
            "text": ["Hi."],
            "choices": [
                {
                    "text": ["How would you like to be POW champion?"],
                    "reply": {
                        "text": ["Really, you think I'm ready? I'm not sure if the fans are, but Hank talked to me about it too. If you both think it's a good idea .. "],
                        "choices": []
                    }
                },
                {
                    "text": ["What do you think of Hank?"],
                    "reply": {
                        "text": ["Hank was really kind to hire me. I didn't have much experience wrestling, and being an immigrant with a name like mine didn't really make me a promised star. But he gave me a shot, and I guess I have to prove that he didn't make a mistake."],
                        "choices": []
                    }
                },
                {
                    "text": ["See you later."],
                    "reply": {
                        "text": ["Okay, see you."],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "success_post_event": {
            "text": ["Wow .. I can't believe that actually happened. That went well, right?"],
            "choices": [
                {
                    "text": ["It went really well."],
                    "reply": {
                        "text": ["Thank you .. the fans, they really liked me .. "],
                        "choices": []
                    }
                },
                {
                    "text": ["There's a long way to go."],
                    "reply": {
                        "text": ["Of course .. I hope I'm ready for it."],
                        "choices": []
                    }
                }
            ]
        },
        "failure_post_event": {
            "text": ["I'm so sorry .. I don't know what happened out there. The fans were silent and I couldn't handle it. I lost track of the match."],
            "choices": [
                {
                    "text": ["It's not your fault."],
                    "reply": {
                        "text": ["I should have tried harder. I just froze. I'm sorry .. What are we going to do now? The fans .. they just ignored me."],
                        "choices": [
                            {
                                "text": ["We'll figure something out."],
                                "reply": {
                                    "text": ["Okay .. "],
                                    "choices": []
                                }
                            }
                        ]
                    }
                },
                {
                    "text": ["You could have at least tried to make it work."],
                    "reply": {
                        "text": ["I know .. I just froze. I couldn't focus and it just got worse and worse .. I'm sorry."],
                        "choices": [
                            {
                                "text": ["I'll try to salvage what I can."],
                                "reply": {
                                    "text": ["Okay .. sorry, again."],
                                    "choices": []
                                }
                            }
                        ]
                    }
                }
            ]
        },
        "success_next_event": {
            "text": ["Hi."],
            "choices": [
                {
                    "text": ["How's it like being champion?"],
                    "reply": {
                        "text": ["I never thought I'd be champion one day, but here I am. I'm just soaking in every moment of it."],
                        "choices": []
                    }
                },
                {
                    "text": ["I'll see you later."],
                    "reply": {
                        "text": ["Okay, see you."],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "failure_next_event": {
            "text": ["Hi."],
            "choices": [
                {
                    "text": ["How's it like being champion?"],
                    "reply": {
                        "text": ["Not good. I'm sure you can tell. The fans don't like me, the women in the back make fun of me. Please end this as soon as you can. I just want to be out of the spotlight."],
                        "choices": []
                    }
                },
                {
                    "text": ["I'll see you later."],
                    "reply": {
                        "text": ["Okay."],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "success_normal": {
            "text": ["Hi."],
            "choices": [
                {
                    "text": ["How're you doing?"],
                    "reply": {
                        "text": ["Things are .. good. I kind of feel like I belong here. The women actually respect me."],
                        "choices": []
                    }
                },
                {
                    "text": ["I'll see you later."],
                    "reply": {
                        "text": ["Okay, see you."],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "failure_normal": {
            "text": ["Hi."],
            "choices": [
                {
                    "text": ["How're you doing?"],
                    "reply": {
                        "text": ["I'm okay. Just trying to stay away from people as much as I can."],
                        "choices": []
                    }
                },
                {
                    "text": ["I'll see you later."],
                    "reply": {
                        "text": ["Okay."],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        }
    },
    "Lady Julia": {
        "introduction": {
            "text": ["Hey! Hank tells me you're the new booker. It's nice to meet you."],
            "choices": [
                {
                    "text": ["Tell me about yourself Lady Julia."],
                    "reply": {
                        "text": ["Well my name's Julia Duncan. I'm 25, an actress. Oh, and I'm a former gymnast! You should see the things I can do in the ring."],
                        "choices": [
                            {
                                "text": ["Why did you join POW?"],
                                "reply": {
                                    "text": ["I was waiting on a TV host role but the production got delayed. The next day I saw an ad for this wrestling promotion in the paper and signed up. They saw my gymnastics background and I was hired!",
                                             "Now I'm here to get my name out and try to land a decent acting role. You're going to help turn me into a star, right?"],
                                    "choices": [
                                        {
                                            "text": ["I'll do my best."],
                                            "reply": {
                                                "text": ["Once you see me work, you'll know I can be a star here. People want to see a young, talented woman become champion. And the sponsors want a pretty face to put on the covers."],
                                                "choices": []
                                            }
                                        }
                                    ]
                                }
                            }
                        ]
                    }
                },
                {
                    "text": ["Okay, talk later."],
                    "reply": {
                        "text": ["Buh-bye."],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "confident": {
            "text": ["Hey!"],
            "choices": [
                {
                    "text": ["How would you like to be POW champion?"],
                    "reply": {
                        "text": ["Are you kidding? Yes! Of course! I knew you'd see it. I'm so ready to be champion. The fans will love it and Hank needs a real star for the sponsors. You're making the right choice with me."],
                        "choices": []
                    }
                },
                {
                    "text": ["What do you think of Hank?"],
                    "reply": {
                        "text": ["Hank's .. well he's smart and he knows what he's doing. He was convinced I could be a star as soon as he saw me. I think he'll figure out a way to get us those sponsors."],
                        "choices": []
                    }
                },
                {
                    "text": ["Who do you think could be a star for POW?"],
                    "reply": {
                        "text": ["Honestly, I mean there are a lot of talented women in the back, but to be a star, you need something else. You need real talent and charisma. And I don't think you'll find that anyone else has that star power but me."],
                        "choices": []
                    }
                },
                {
                    "text": ["See you later."],
                    "reply": {
                        "text": ["Buh-bye."],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "success_post_event": {
            "text": ["That went so well .. it was tough, remembering all those spots, with the crowd all excited. I'm just gonna go to my room for a bit .. "],
            "choices": [
                {
                    "text": ["Okay. Are you alright?"],
                    "reply": {
                        "text": ["Yes, yes, I'll be right out to join you guys .. "],
                        "choices": []
                    }
                }
            ]
        },
        "success_next_event": {
            "text": ["..."],
            "choices": [
                {
                    "text": ["Why did you leave right after your win?"],
                    "reply": {
                        "text": ["I had some .. celebrating to do. I'm the champion now! Champion, champion, champion."],
                        "choices": []
                    }
                },
                {
                    "text": ["Are you high?"],
                    "reply": {
                        "text": ["What? No .. I'm perfectly fine. I'm the champion, the staarrr of this show .. and I'm here. You need me?"],
                        "choices": []
                    }
                },
                {
                    "text": ["Can you perform tonight?"],
                    "reply": {
                        "text": ["Of course I can perform .. I can wrestle .. I can talk .. I'm Lady Juuulia. Just .. listen here. Put me in something easy okay? Just for tonight."],
                        "choices": []
                    }
                },
                {
                    "text": ["I thought you were ready to be champion."],
                    "reply": {
                        "text": ["I was. I am .. I just. I worked so hard on it, on being the best. Woman. Here. It's just a lot .. you know .. being champion. And all that."],
                        "choices": [
                            {
                                "text": ["Isn't this what you wanted? So you could get your name out there?"],
                                "reply": {
                                    "text": ["Yeah. This is what I wanted. To be the wrestling champion of a show no one takes seriously! So I can try to get a half decent acting role .. so I don't have to keep regretting choosing a career that no one respects."],
                                    "choices": [
                                        {
                                            "text": ["You are respected here."],
                                            "reply": {
                                                "text": ["Give me a break. Respected by who? Freaks in costumes? Just .. forget it."],
                                                "choices": []
                                            }
                                        }
                                    ]
                                }
                            }
                        ]
                    }
                },
                {
                    "text": ["Okay, talk later."],
                    "reply": {
                        "text": ["Byeee."],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "success_normal": {
            "text": ["Hey."],
            "choices": [
                {
                    "text": ["How're you doing?"],
                    "reply": {
                        "text": ["Better. Much better. I'm sorry for what I said when I was .. you know. That wasn't me. And I'm not on that stuff anymore.",
                                 "Anyway, I've been training more, trying to get as good as I was in the ring before. I'm gonna stay here, work hard, and figure things out along the way."],
                        "choices": []
                    }
                },
                {
                    "text": ["Okay, talk later."],
                    "reply": {
                        "text": ["Buh-bye."],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        }
    },
    "Violet": {
        "introduction": {
            "text": ["Hello."],
            "choices": [
                {
                    "text": ["Tell me about yourself Violet."],
                    "reply": {
                        "text": ["My name's Madie Hill, or as people know me, Violet. You may have seen me on TV if you were watching wrestling in the late 70's. I started out as a valet in Big Action Wrestling, and ended up being their champion after they introduced a women's title in '78."],
                        "choices": [
                            {
                                "text": ["How long have you been wrestling?"],
                                "reply": {
                                    "text": ["Since I was 19. I started in a local promotion in Ohio until Big Bob signed me up for BAW in '75. And that lasted for five, no, six good years."],
                                    "choices": [
                                        {
                                            "text": ["Why did you leave?"],
                                            "reply": {
                                                "text": ["My husband, Doug, and I decided it was time to start a family. I had to vacate the title, say goodbye to everyone and leave. Had my little Markie. He's 4 now. My husband brings him to the shows sometimes; you should meet him! He's such a sweetheart."],
                                                "choices": [
                                                    {
                                                        "text": ["You're back wrestling now?"],
                                                        "reply": {
                                                            "text": ["Yes. I was a real star in Big Action Wrestling. I couldn't leave all that behind. Doug didn't think I could wrestle while being a mother; oh we had a lot of fights about that. But he came around."],
                                                            "choices": [
                                                                {
                                                                    "text": ["Why did you join POW?"],
                                                                    "reply": {
                                                                        "text": ["I went to BAW first, but 5 years is a long time. The whole show had changed. The women's title was a joke. They wanted me as a valet. A valet! I was a good wrestler and the fans wanted to see me perform in the ring, not on the sidelines talking for some man.",
                                                                                 "You know what it really was? They didn't think I could wrestle anymore, with the pregnancy and the long absence. And maybe they were right.",
                                                                                 "But POW gave me a shot. Hank said he believed I could wrestle, and wrestle well, with the right training. So I trusted him and, well, here I am."],
                                                                        "choices": []
                                                                    }
                                                                }
                                                            ]
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                }
                            }
                        ]
                    }
                },
                {
                    "text": ["Okay, see you later."],
                    "reply": {
                        "text": ["Bye for now."],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "normal": {
            "text": ["Hello."],
            "choices": [
                {
                    "text": ["How would you like to be POW champion?"],
                    "reply": {
                        "text": ["Champion? That's a big ask. I've been here a few months and I've been working matches, but I still don't feel that comfortable in the ring.",
                                 "After I had Markie, for four years I didn't train or wrestle or even work out. I'm 35 now. I'm not the Violet that used to put on clinics in the ring. Right now I just get in, do my job and get out."],
                        "choices": [
                            {
                                "text": ["And you don't think you'll ever get back to that level?"],
                                "reply": {
                                    "text": ["I'm trying to. It sucks to be in the ring and know you could be doing so much better. I need more training, more matches."],
                                    "choices": []
                                }
                            }
                        ]
                    }
                },
                {
                    "text": ["What do you think of Hank?"],
                    "reply": {
                        "text": ["Hank's a good friend. I worked with him on a few shows before I joined BAW and I respect him. He hired me as a wrestler even though everyone else thought I was past my prime. He thinks I can go back to being the old me."],
                        "choices": []
                    }
                },
                {
                    "text": ["How's it like, being a mother while being a wrestler?"],
                    "reply": {
                        "text": ["I didn't think I could do it before, when Markie was little. I just didn't have the time. But now .. you know he tucks himself in at night? Like he doesn't want us to read him his stories. He just tells us goodnight, goes into bed and goes to sleep.",
                                 "He's so grown up now. Doug takes care of him when I'm here and I go home as soon as I'm done. We're making it work."],
                        "choices": []
                    }
                },
                {
                    "text": ["See you."],
                    "reply": {
                        "text": ["Okay, bye."],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "confident": {
            "text": ["Hello."],
            "choices": [
                {
                    "text": ["How would you like to be POW champion?"],
                    "reply": {
                        "text": ["You know, I'm feeling pretty good about myself. My performances have improved, training has been going well. Being champion is a huge weight on anyone's shoulders, but I've been there before. I know how it's done."],
                        "choices": []
                    }
                },
                {
                    "text": ["What do you think of Hank?"],
                    "reply": {
                        "text": ["Hank's a good friend. I worked with him on a few shows before I joined BAW and I respect him. He hired me as a wrestler even though everyone else thought I was past my prime. He thinks I can go back to being the old me."],
                        "choices": []
                    }
                },
                {
                    "text": ["See you."],
                    "reply": {
                        "text": ["Sure, bye."],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "success_post_event": {
            "text": ["That was a terrific match! I felt like myself in the ring. After so long, I felt like I could go. Oh, and seeing Markie in the crowd made it so much better when I won.",
                     "I need to go see him and hug him! He must be driving my husband crazy after a match as long as that."],
            "choices": [
                {
                    "text": ["You did well. Markie and Doug will be proud of you."],
                    "reply": {
                        "text": ["Oh I'm so glad they were there. Thank you for helping me with everything."],
                        "choices": []
                    }
                },
                {
                    "text": ["You're a star now, so you won't be leaving early from shows, right?"],
                    "reply": {
                        "text": ["Being champion means the company comes first, I know that. We'll get a nanny, or Doug can change his shifts. We'll have to figure something out."],
                        "choices": []
                    }
                }
            ]
        },
        "failure_post_event": {
            "text": ["I .. I don't know what happened there. I thought I could do it off the top rope, give the fans a big spot before the .. where's the doctor, is he here yet?"],
            "choices": [
                {
                    "text": ["Doctor's coming. Are you alright?"],
                    "reply": {
                        "text": ["I think so .. my arms feel a bit weird, but I think I'm fine. I've done that move before. I thought I could do it again .."],
                        "choices": [
                            {
                                "text": ["You're okay, you didn't suffer an injury."],
                                "reply": {
                                    "text": ["I was this close to landing on my neck. Just an inch or two and .. where's Markie? I saw him in the crowd .. Doug must be so scared. I need to go see them."],
                                    "choices": []
                                }
                            }
                        ]
                    }
                }
            ]
        },
        "success_next_event": {
            "text": ["Hello."],
            "choices": [
                {
                    "text": ["How's it like being champion?"],
                    "reply": {
                        "text": ["It's stressful, but good stressful, you know? Doug got a shift change so I can be here longer. He knows how important being champion is to me."],
                        "choices": []
                    }
                },
                {
                    "text": ["Talk later."],
                    "reply": {
                        "text": ["Sure, bye."],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "failure_next_event": {
            "text": ["Hello."],
            "choices": [
                {
                    "text": ["Are you okay?"],
                    "reply": {
                        "text": ["Yeah. I'm okay. I'm sorry I wasn't here after the show."],
                        "choices": [
                            {
                                "text": ["You're not going to be full-time anymore?"],
                                "reply": {
                                    "text": ["I know I'm the champion, and the champion needs to be here every show .. I just realized, after that, that spot, that my body isn't what it used to be. I'm older now, I have a family. I have a baby boy .. what if I had landed on my neck? What would I do if I couldn't take Markie out for a walk .. "],
                                    "choices": [
                                        {
                                            "text": ["It's okay. I get it."],
                                            "reply": {
                                                "text": ["I know nothing happened .. but .. you know Doug was crying that night. He cried asking me if I was okay. I thought a lot that night, about my career, about what I want. And I made my decision.",
                                                         "I'll still be here, but not every week, not every month. And I can't be who I was before. That was another woman, in another time."],
                                                "choices": []
                                            }
                                        }
                                    ]
                                }
                            }
                        ]
                    }
                },
                {
                    "text": ["Talk later."],
                    "reply": {
                        "text": ["Okay, bye."],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "success_normal": {
            "text": ["Hey."],
            "choices": [
                {
                    "text": ["How're you doing?"],
                    "reply": {
                        "text": ["Oh, really good. I'm grateful for what you did for me. You made my comeback possible."],
                        "choices": [
                            {
                                "text": ["How's Markie?"],
                                "reply": {
                                    "text": ["He's doing well. Doug can't bring him to the shows that often because he's so tired from his new shift. But I'll get to see him once we're done with the show. "],
                                    "choices": []
                                }
                            }
                        ]
                    }
                },
                {
                    "text": ["Talk later."],
                    "reply": {
                        "text": ["Sure, bye."],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "failure_normal": {
            "text": ["Hey."],
            "choices": [
                {
                    "text": ["How're you doing?"],
                    "reply": {
                        "text": ["I'm good. Taking it easy in the ring. Spending more time at home. I think this is a better role for me, working when I can, helping the younger talent."],
                        "choices": [
                            {
                                "text": ["How's Markie?"],
                                "reply": {
                                    "text": ["Oh he's splendid. Doug doesn't bring him to the shows anymore, after the incident. But I'm working real safe now, so maybe I'll ask Doug to bring him, just for one show. I'd like to see him cheering me on again."],
                                    "choices": []
                                }
                            }
                        ]
                    }
                },
                {
                    "text": ["Talk later."],
                    "reply": {
                        "text": ["Okay, bye."],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        }
    },
    "Zora": {
        "introduction": {
            "text": ["Yeah?"],
            "choices": [
                {
                    "text": ["Tell me about yourself Zora."],
                    "reply": {
                        "text": ["What is this, some sort of interview? I'm one of the wrestlers here."],
                        "choices": [
                            {
                                "text": ["I just wanted to know about you."],
                                "reply": {
                                    "text": ["Oh, you want to know about me. Okay, let's see. I was a rising star here in POW until the last show, where I was put in the spotlight. Hank thought it would be this great star making moment, but it failed.",
                                             "The match sucked, the story sucked, and the fans turned on me. So that's who I am right now. Someone the fans don't want to see."],
                                    "choices": [
                                        {
                                            "text": ["Why was it so bad?"],
                                            "reply": {
                                                "text": ["Because the fans didn't want me! I gave it my best, but they didn't want me. Hank convinced me I was ready, and I stupidly went along with it even though I knew better."],
                                                "choices": [
                                                    {
                                                        "text": ["I'll try to turn the fans around."],
                                                        "reply": {
                                                            "text": ["Yeah, good luck with that. They seem pretty much done with me."],
                                                            "choices": []
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                }
                            }
                        ]
                    }
                },
                {
                    "text": ["Okay, bye."],
                    "reply": {
                        "text": ["Yeah, bye."],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "normal": {
            "text": ["Yeah?"],
            "choices": [
                {
                    "text": ["How would you like to be POW champion?"],
                    "reply": {
                        "text": ["Champion? Don't you know how the fans treated me the last time I was in the spotlight? They haven't forgotten. No way, I'm not putting myself through that again."],
                        "choices": [
                            {
                                "text": ["Even if I turned the fans around on you?"],
                                "reply": {
                                    "text": ["You must be crazy if you think you can do that. Listen, they don't want me, and I don't want to be champion like that."],
                                    "choices": []
                                }
                            }
                        ]
                    }
                },
                {
                    "text": ["What do you think of Hank?"],
                    "reply": {
                        "text": ["Hank is an idiot. He's a bad judge of the business, and I don't know if you're any better."],
                        "choices": []
                    }
                },
                {
                    "text": ["You don't seem to like it here."],
                    "reply": {
                        "text": ["No, I don't. But it's my job so I'll do what's needed. I had to go through a lot to get here and I'm not just gonna quit because of one night."],
                        "choices": []
                    }
                },
                {
                    "text": ["See you later."],
                    "reply": {
                        "text": ["Yeah, bye."],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "confident": {
            "text": ["Yeah?"],
            "choices": [
                {
                    "text": ["How would you like to be POW champion?"],
                    "reply": {
                        "text": ["You sound exactly like Hank did. He was so confident I could be his star. And then I flopped."],
                        "choices": [
                            {
                                "text": ["Things are different now. You're over with the fans."],
                                "reply": {
                                    "text": ["I might be, but that doesn't mean they'll accept me as champion. I can't take a reaction like that again."],
                                    "choices": [
                                        {
                                            "text": ["It won't be like before."],
                                            "reply": {
                                                "text": ["Look, I know being champion would be a step up. I want to be the champion. I just don't believe you can pull it off. You'll have to come up with something really amazing if you want the fans to see me differently."],
                                                "choices": []
                                            }
                                        }
                                    ]
                                }
                            }
                        ]
                    }
                },
                {
                    "text": ["What do you think of Hank?"],
                    "reply": {
                        "text": ["Hank is an idiot. He's a bad judge of the business, and I don't know if you're any better."],
                        "choices": []
                    }
                },
                {
                    "text": ["See you later."],
                    "reply": {
                        "text": ["Yeah, bye."],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "success_post_event": {
            "text": ["That actually worked. They were on my side. I'm champion and they were on my side."],
            "choices": [
                {
                    "text": ["Good job, you did well."],
                    "reply": {
                        "text": ["It wouldn't have worked without the right booking. I'll see you soon .. I need to take all this in."],
                        "choices": []
                    }
                },
                {
                    "text": ["I told you it would work."],
                    "reply": {
                        "text": ["You did a much better job than Hank, that's for sure. I'll see you soon .. I need to take all this in."],
                        "choices": []
                    }
                }
            ]
        },
        "failure_post_event": {
            "text": ["I told you it wouldn't work! The fans turned on me, just like before. You made me champion even though the fans wouldn't have it. Were you that desperate to make a star?!"],
            "choices": [
                {
                    "text": ["I'm sorry, I thought it would work."],
                    "reply": {
                        "text": ["You were wrong. I don't know what we're going to do now. I can't be the champion like this."],
                        "choices": []
                    }
                },
                {
                    "text": ["Hank thought you could do it."],
                    "reply": {
                        "text": ["I'm going to kill him when I see him. And I'm not going to be your champion."],
                        "choices": []
                    }
                }
            ]
        },
        "success_next_event": {
            "text": ["Yeah?"],
            "choices": [
                {
                    "text": ["How's it like being champion?"],
                    "reply": {
                        "text": ["How do you think? It's unreal. The fans are behind me and I can't let them down. I need to stay on top of my game."],
                        "choices": []
                    }
                },
                {
                    "text": ["Talk to you later."],
                    "reply": {
                        "text": ["Yeah, sure."],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "failure_next_event": {
            "text": ["Yeah?"],
            "choices": [
                {
                    "text": ["How's it like being champion?"],
                    "reply": {
                        "text": ["What, you expect me to be grateful that I'm the champion? You need to take this title off me. I can't go out there every night and be rejected by the fans."],
                        "choices": []
                    }
                },
                {
                    "text": ["Talk to you later."],
                    "reply": {
                        "text": ["Yeah, bye."],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "success_normal": {
            "text": ["Yeah?"],
            "choices": [
                {
                    "text": ["How're you doing?"],
                    "reply": {
                        "text": ["Fine. Doing my job like always. Listen .. "],
                        "choices": [
                            {
                                "text": ["Yes?"],
                                "reply": {
                                    "text": ["Thank you, for making me believe I'm not a failure here .. yeah, just wanted to say that. Now get out, I've got to focus."],
                                    "choices": []
                                }
                            }
                        ]
                    }
                },
                {
                    "text": ["Talk to you later."],
                    "reply": {
                        "text": ["Yeah, sure."],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "failure_normal": {
            "text": ["Yeah?"],
            "choices": [
                {
                    "text": ["How're you doing?"],
                    "reply": {
                        "text": ["Still here, doing what I need to do. Trying to put my disasters behind me."],
                        "choices": []
                    }
                },
                {
                    "text": ["Talk to you later."],
                    "reply": {
                        "text": ["Yeah, bye."],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        }
    },
    "Hank Hughes": {
        "introduction": {
            "text": ["Hey. I'm Hank Hughes, the man in charge of Passion of Wrestling. You're gonna be helping me put the shows together.",
                     "This is a small promotion trying to stand on its own feet. Our champion, Merry Martha, isn't really what you would call a draw. So I've come up with a plan to build up new stars, and once we do, put on a premier event for some sponsors so we can get them to sign with us.",
                     "To turn someone into a star, you need to give them a good run and then make them the POW Champion. I have my eyes on four women for that role: Lady Julia, Violet, Natasha Ali and Zora. Get to know them and see who you want to focus on first.",
                     "It's your first day, so go talk to the talent and plan for your first show."],
            "choices": [
                {
                    "text": ["Why did you join POW?"],
                    "reply": {
                        "text": ["My previous project failed. It was an out-there TV pilot: Psychos in Space. Heard of it? Nah, didn't think so. Anyway, I was strapped for cash, and I got feelers for this wrestling show that needed a producer. The owners and I talked, and after some commitments and promises, I was on board.",
                                 "That was, let's see, half a year ago. We couldn't get any sponsors, 'cause the show sucked thanks to the owners putting their idiotic ideas into it. So we sat down and negotiated, and I promised to stay if I got full creative control. Oh, and I got to hire you."],
                        "choices": [
                            {
                                "text": ["Psychos in Space, what was that about?"],
                                "reply": {
                                    "text": ["I don't wanna talk about it, okay? POW, that's where I'm at now."],
                                    "choices": []
                                }
                            }
                        ]
                    }
                },
                {
                    "text": ["What makes POW unique?"],
                    "reply": {
                        "text": ["We're the only women's wrestling show in the country! We've got ladies of all kinds here; we just need to showcase their talents."],
                        "choices": []
                    }
                },
                {
                    "text": ["Why those four women?"],
                    "reply": {
                        "text": ["I have a plan, okay? I hired those women and I've worked with them. I know they can be our stars. Talk to them, work with them and you'll know too.",
                                 "And whatever you do, don't put them in a position where they want to leave. I need them for the premier event."],
                        "choices": []
                    }
                },
                {
                    "text": ["What's my role here?"],
                    "reply": {
                        "text": ["You'll put the shows together. You know the wrestling business, so I'm hoping you can make stars out of these women."],
                        "choices": []
                    }
                },
                {
                    "text": ["Okay, see you."],
                    "reply": {
                        "text": ["See you around."],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "normal": {
            "text": ["Come on, let's get to booking."],
            "choices": [
                {
                    "text": ["What do you think of Lady Julia?"],
                    "reply": {
                        "text": ["She's our star. She has the ability, the confidence and the charisma. And the sponsors; they're gonna love her. Don't mess her up."],
                        "choices": []
                    },
                    "person_name": "Lady Julia"
                },
                {
                    "text": ["What do you think of Violet?"],
                    "reply": {
                        "text": ["Violet? She's a known talent, was the champion in Big Action Wrestling. Scooped her up just as she was returning to the ring. She may not work as well as she used to, but she has what it takes. We're gonna give her the best training we can and get her back to the top where she belongs."],
                        "choices": []
                    },
                    "person_name": "Violet"
                },
                {
                    "text": ["What do you think of Natasha?"],
                    "reply": {
                        "text": ["She's a quiet girl. A little awkward. You wouldn't really think she could be a star, right? But when I saw her in tryouts, no one worked harder than her. She's got what it takes. I saw that when she stepped into the ring the first time. You just gotta make her believe it too."],
                        "choices": []
                    },
                    "person_name": "Natasha Ali"
                },
                {
                    "text": ["What do you think of Zora?"],
                    "reply": {
                        "text": ["Zora .. she could've been our star. I thought I had it all figured out with her, but things didn't go as planned. Anyway, she's in your hands now. She has the skills and the charisma; you just need to give her some good booking."],
                        "choices": []
                    },
                    "person_name": "Zora"
                },
                {
                    "text": ["How do I turn someone into a star?"],
                    "reply": {
                        "text": ["To become a star for the company, you need a good run that ends in winning the POW Championship, our company's flagship title. If the championship winning match goes well, it should thrust that talent into stardom in the eyes of the fans."],
                        "choices": []
                    }
                },
                {
                    "text": ["What if someone else gets over?"],
                    "reply": {
                        "text": ["They could get over, doesn't mean they're a star. These four have what it takes. They're what I need to get the sponsors on board. So put your focus on them."],
                        "choices": []
                    }
                },
                {
                    "text": ["Tell me more about this premier event."],
                    "reply": {
                        "text": ["Okay, picture this. A concert hall, a ring on the stage, fans filled to the balconies. All red decor, spotlights, a dedicated camera crew. And our top stars in a showcase match, which I'm still working on, but a match that's gonna put them over big time with the sponsors."],
                        "choices": []
                    }
                },
                {
                    "text": ["Okay, see you later."],
                    "reply": {
                        "text": ["Yeah, see you."],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "natasha_ali_success": {
            "text": ["Natasha did it. She took her shot and looked like a total star. Good job building her up. The sponsors are gonna love an underdog."],
            "choices": []
        },
        "natasha_ali_failure": {
            "text": ["You thought Natasha was ready to be the champion, not being a main eventer? She had to believe in herself and she didn't believe she could be a star. She went completely blank out there!",
                     "We have to figure out what to do with her. We might have to give the championship to someone else because her popularity with the fans has nose-dived."],
            "choices": []
        },
        "lady_julia_success": {
            "text": ["Lady Julia finally showed up today. High as a kite. What did you say to her?"],
            "choices": [
                {
                    "text": ["Nothing. She left right after her win."],
                    "reply": {
                        "text": ["Damn. I thought she could do this. She seemed so confident about being champion. Look, we need to get her sobered up and figure out what to do. Go talk to her. And I don't think it would be the best idea to put her in a match right now."],
                        "choices": []
                    }
                }
            ]
        },
        "violet_success": {
            "text": ["Did you see Violet out there? It looked like a main event out of Big Action Wrestling! We're hitting the big leagues, and we got a star like Violet on our roster! The sponsors are going to love seeing her perform like this."],
            "choices": []
        },
        "violet_failure": {
            "text": ["Who the hell okay-ed that top rope spot with Violet? Was that you? She looked like a total star until that happened! She wasn't in the ring conditioning to do a spot like that.",
                     "She showed up today, still shaken up. Told me she can't work full-time anymore. That's our champion! Just .. go talk to her, okay?"],
            "choices": []
        },
        "zora_success": {
            "text": ["Zora's a star! After I drove her straight into the trash, you managed to turn it around. I gotta admit, you're a much better booker than I was."],
            "choices": []
        },
        "zora_failure": {
            "text": ["Zora must be pissed. Did you see how the fans treated her after she won? She had to be over with them to have any chance of becoming a star.",
                     "Listen .. don't beat yourself up. I've been there too. Maybe she isn't meant to be our star. Just don't tell her you saw me come in today, okay?"],
            "choices": [
                {
                    "text": ["What do we do with her?"],
                    "reply": {
                        "text": ["I guess we make the best out of her run as champion and move on."],
                        "choices": []
                    }
                }
            ]
        },
        "success_goals": {
            "text": ["You have a knack for making stars, you know? You've done well with all the women I talked to you about.",
                     "I think we're ready for our premier event. I talked to the owners and they want it done at the next monthly event.",
                     "I've come up with the perfect match for our stars and all of them have agreed to be in it. It's called Femme Fatale; an epic, story-driven match that's bound to interest the sponsors. I trust your judgement with the rest of the show, so book it as you want."],
            "choices": []
        },
        "failure_goals": {
            "text": ["The owners are on my back to put on the premier event. I told them we don't have the star power, but they aren't listening.",
                     "I have to hold it at the next monthly event. Sponsors from some big TV networks are going to be there and I have no idea what we're going to put on for them. My showcase match won't work without more stars.",
                     "You'll have to put on the best show you can with the talent we have. I can't get humiliated out there."],
            "choices": []
        },
        "success_pre_premier_event": {
            "text": ["We're finally here. The Femme Fatale match is going to steal the show! Not that your booking won't be great, it will be, but I've been working on this for weeks.",
                     "Did you know that it incorporates some elements from my other TV pilot: Time Mechanics? .. okay, well, put on a good show. I'll see you out there."],
            "choices": []
        },
        "failure_pre_premier_event": {
            "text": ["Well, this is it .. yeah, I'm nervous, okay? The sponsors are going to be here and the owners are expecting an excellent show.",
                     "We really needed more stars for this. I hope the sponsors see something they like .. our future depends on it."],
            "choices": []
        },
        "success_ending": {
            "text": ["The sponsors loved it! We managed to get three, yes, three sponsors to sign with us! POW's star power convinced them to pay big money up front, some of which the owners made available for the company.",
                     "I've spoken with the owners, and since my deal with them was to get them some sponsors, well, this it for me. I've got big plans for another project, and I told them you were ready to take over the reins."],
            "choices": [
                {
                    "text": ["You're leaving?"],
                    "reply": {
                        "text": ["Yeah, that was the deal. Don't worry, you can do this on your own. It's just time for me to move on. Never could stay on one project for long.",
                                 "Oh, and a little parting gift for you. One of my great ideas, the Femme Fatale match, is yours to use. I believe in being generous with my creativity. Book it wherever you go, just make sure you give me credit."],
                        "choices": [
                            {
                                "text": ["What are you going to do now?"],
                                "reply": {
                                    "text": ["Another TV pilot: Monsters on the Moon. It's been in the back of my head for years. I talked to some people who are interested in sponsoring production. If everything goes well, you'll be seeing it on your television next summer! I'm gonna go say goodbye to the women."],
                                    "choices": []
                                }
                            }
                        ]
                    }
                }
            ]
        },
        "failure_ending": {
            "text": ["It didn't work. The sponsors didn't sign. The owners called me in afterwards .. and, well .. that was the last straw for them. They're shutting the production down."],
            "choices": [
                {
                    "text": ["That's it?"],
                    "reply": {
                        "text": ["Yeah, that's it. I asked them for some more time, but they didn't budge. No sponsors, despite all this effort, means no interest from them to keep this afloat any longer. It's time to move on, for all of us."],
                        "choices": [
                            {
                                "text": ["What now?"],
                                "reply": {
                                    "text": ["Go home. You don't wanna be the one to tell everyone in the back that they're out of a job. I'll go talk to them."],
                                    "choices": []
                                }
                            }

                        ]
                    }
                }

            ]
        },
        "information": {
            "name": "Hank Hughes",
            "producer": true,
            "graphic": {"accessory": {"object": 31, "colors": ["0xD09F15"]},
                        "accessory2": {"object": -1, "colors": ["0xEFEFEF"]},
                        "accessory3": {"object": -1, "colors": null}, "body": {"object": 0, "colors": ["0xFFD9B6"]},
                        "bottoms": {"object": 0, "colors": ["0x6a87a4"]}, "elbow": {"object": -1, "colors": null},
                        "eyes": {"object": 0, "colors": ["0x000000"]}, "facepaint": {"object": -1, "colors": null},
                        "facialHair": {"object": 15, "colors": ["0xcccbcb"]},
                        "hair": {"object": 32, "colors": ["0xdbdbdb"]}, "knee": {"object": -1, "colors": null},
                        "shoes": {"object": 1, "colors": ["0x242424", "0x242424"]},
                        "tattoo": {"object": 2, "colors": ["0x31661A"]},
                        "torso": {"object": 48, "colors": ["0xd1d1d1", "0xcecece"]}, "alternate_attires": []}
    }
    },
    "Scarlet": {
        "normal": {
            "text": ["What?"],
            "choices": [
                {
                    "text": ["Who do you think could be a star for us?"],
                    "reply": {
                        "text": ["Well it won't be me. Have you seen this face? I'm not gonna be on the cover of any posters or tapes."],
                        "choices": []
                    }
                },
                {
                    "text": ["See you."],
                    "reply": {
                        "text": ["Yeah."],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        }
    },
    "Joan of Narcs": {
        "normal": {
            "text": ["Need something?"],
            "choices": [
                {
                    "text": ["Who do you think could be a star for us?"],
                    "reply": {
                        "text": ["Anyone but Lady Julia. She walks around here like she's the top star, but there are a lot more deserving ladies here."],
                        "choices": []
                    }
                },
                {
                    "text": ["Gotta go."],
                    "reply": {
                        "text": ["Bye."],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        }
    },
    "Fortuna": {
        "normal": {
            "text": ["Hey there."],
            "choices": [
                {
                    "text": ["Who do you think could be a star for us?"],
                    "reply": {
                        "text": ["Violet, definitely. So what if she had a baby? Women can do amazing things after childbirth. She's legit."],
                        "choices": []
                    }
                },
                {
                    "text": ["Bye for now."],
                    "reply": {
                        "text": ["See ya."],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        }
    },
    "Lora the Lioness": {
        "normal": {
            "text": ["Yo."],
            "choices": [
                {
                    "text": ["Who do you think could be a star for us?"],
                    "reply": {
                        "text": ["Oh, Natasha. She's my homegirl, we came here together, and I know she has what it takes to be a star."],
                        "choices": []
                    }
                },
                {
                    "text": ["Later."],
                    "reply": {
                        "text": ["Bye!"],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        }
    },
    "Merry Martha": {
        "normal": {
            "text": ["Hi there."],
            "choices": [
                {
                    "text": ["Who do you think could be a star for us?"],
                    "reply": {
                        "text": ["Star? We already have a star in me. We packed the farmer's market with my title match! Oh it was such a thrill."],
                        "choices": []
                    }
                },
                {
                    "text": ["Goodbye."],
                    "reply": {
                        "text": ["Bye dear."],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        }
    },
}

export {powDialog}